"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = validate;
const schemaMethods = __importStar(require("../schemaMethods"));
const aggregateFunction_1 = require("./aggregateFunction");
const calcFunction_1 = require("./calcFunction");
const defineSchema_1 = require("./defineSchema");
const fixAndMergeSchema_1 = require("./fixAndMergeSchema");
const getRuleMessage_1 = require("./getRuleMessage");
const getValidations_1 = require("./getValidations");
const ValidationResult_1 = require("./ValidationResult");
const validFunction_1 = require("./validFunction");
const validPropFunction_1 = require("./validPropFunction");
const validationMessages_1 = require("../validationMessages");
const schemaProxy_1 = require("./schemaProxy");
const functions_1 = require("../WrappedProperty/functions");
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * funkcja tworząca property wyliczające wartośc pola schematu
 *
 * @param {*} $schema
 * @param {*} internal
 * @param {string} field
 * @returns
 */
function wrapSchemaProp($schema, internal, field) {
    const schema = internal.schema;
    internal.needsCalcArgs = true;
    const v = schema[field];
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    // console.log(`create valid function`, field, v, internal.parent);
    if (schema.cache === undefined) {
        schema.cache = {};
    }
    let ff = schema.cache[`schema_${field}`];
    if (ff === undefined) {
        ff = (0, validPropFunction_1.validPropFunction)(v);
        // console.log('calc func', ff.toString());
        schema.cache[`schema_${field}`] = ff;
    }
    Object.defineProperty($schema, field, {
        enumerable: true,
        get() {
            try {
                return ff.apply(internal.parentModel, internal.calcargs);
            }
            catch (_a) {
                return undefined;
            }
        }
    });
}
/**
 * funkcja tworząca wyliczalne property dla okreslonych pól schematu
 *
 * @param {*} $schema wynikowy schemat w którym tworzone są poperty
 * @param {*} internal dane wewnętrzne, m.in. schemat wejsciowy
 * @param {string} type jaki typ property powoduje że jest ono statyczne,
 * w przeciwnym przypadku traktowane jest jako wyliczalne
 * @param {string[]} props jakie pola schematu obudować
 */
function wrapSchemaProps($schema, internal, type, props) {
    for (const field of props) {
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp($schema, internal, field);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
/**
 * dodanie błedu
 *
 * @param {IExtendedValidateOptions} options
 * @param {string} path
 * @param {string} validation
 * @param {*} value
 * @param {string} [message]
 * @returns {IValidationError}
 */
/**
 * funkacja walidująca pojedyńcze pole
 *
 * @param {JSONSchema} schema schemat pola
 * @param {*} data aktualna wartość
 * @param {string} [path=''] ścieżka do pola
 * @param {IExtendedValidateOptions} options opcje walidacji
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @param {*} [parentProxy] obiekt nadrzędny obudowany schemaProxy
 * @returns {(IValidationError | null)} błąd w polu
 */
function validateField(schema, data, path = '', options, parent, key, parentProxy) {
    let schemaIsNumber = false;
    let dataIsNumber = false;
    const $schema = {};
    const internal = { schema };
    let err = null;
    const setError = (validation, expected, value) => {
        err = {
            path,
            validation,
            expected: expected !== undefined
                ? expected
                : $schema[validation] === undefined
                    ? schema[validation]
                    : $schema[validation],
            value: value || data
        };
        if (!options.disableMessages) {
            err.message = (0, getRuleMessage_1.getRuleMessage)({ options, schema }, validation, data, $schema);
        }
        options.errors.push(err);
        if (options.breakOnFirstError) {
            return true;
        }
        return false;
    };
    const funcs = (0, getValidations_1.getValidations)(schema, schema, false);
    switch (schema.type) {
        case 'integer':
        case 'number':
        case 'money':
            wrapSchemaProps($schema, internal, 'number', [
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum',
                'precision'
            ]);
            break;
        case 'string':
            wrapSchemaProps($schema, internal, 'number', ['maxLength', 'minLength']);
            wrapSchemaProps($schema, internal, 'number', ['minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum']);
            break;
        case 'array':
            wrapSchemaProps($schema, internal, 'number', ['maxItems', 'minItems', 'length']);
            break;
    }
    if (schema.enum !== undefined) {
        if (!Array.isArray(schema.enum)) {
            wrapSchemaProp($schema, internal, 'enum');
        }
        else {
            $schema.enum = schema.enum;
        }
    }
    if (schema.required !== undefined &&
        schema.type !== 'object' &&
        (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
        schema.fieldRequired = schema.required;
    }
    wrapSchemaProps($schema, internal, 'boolean', ['fieldRequired', 'disabled']);
    wrapSchemaProps($schema, internal, 'string', ['title', 'shortTitle', 'description']);
    let validFunc = null;
    if (schema.validFunc) {
        internal.needsCalcArgs = true;
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        let tempFunc = schema.cache[`schema_validFunc`];
        if (tempFunc === undefined) {
            tempFunc = (0, validFunction_1.validFunction)(schema, schema.validFunc, false, process.env.NODE_ENV !== 'production' && schema.debug);
        }
        validFunc = ( /*value: any*/) => {
            const funcvalue = tempFunc.apply(internal.parentModel, internal.calcargs);
            if (funcvalue === true || funcvalue === undefined) {
                return null;
            }
            if (funcvalue === false) {
                return 'validFunc';
            }
            return funcvalue;
        };
        funcs.push(validFunc);
    }
    internal.calcFunction = null;
    internal.aggregateFunction = null;
    internal.calcValue = undefined;
    if (options.validateCalculations) {
        if (schema.calc) {
            internal.validateCalculations = true;
            internal.needsCalcArgs = true;
            if (schema.cache === undefined) {
                schema.cache = {};
            }
            let ff = schema.cache.calcFunction;
            if (ff === undefined) {
                schema.cache.calcFunction = ff = (0, calcFunction_1.calcFunction)(schema, false, false, false);
            }
            internal.calcFunction = ff;
        }
        else if (schema.aggregate) {
            internal.validateCalculations = true;
            internal.needsCalcArgs = true;
            if (schema.cache === undefined) {
                schema.cache = {};
            }
            let ff = schema.cache.calcFunction;
            if (ff === undefined) {
                schema.cache.aggregateFunction = ff = (0, aggregateFunction_1.aggregateFunction)(schema, false, false, false);
            }
            internal.aggregateFunction = ff;
        }
    }
    const obj = {
        $key: key,
        $model: data,
        $parent: parent
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    internal.parent = parentProxy;
    if (internal.needsCalcArgs) {
        // const paramData: any[] = [{}, {}, {}, {}, options.external, options.schemaMethods, obj];
        const paramCtx = {
            $root: {},
            $parent: {},
            $parent2: {},
            $parent3: {},
            $external: options.external,
            $methods: options.schemaMethods,
            $obj: obj
        };
        if (parentProxy) {
            // używaj proxy do wyliczeń
            paramCtx.$root = options.$rootProxy;
            if (parentProxy.$parent) {
                paramCtx.$parent = parentProxy.$parent;
                if (parentProxy.$parent.$parent) {
                    paramCtx.$parent2 = parentProxy.$parent.$model;
                    if (parentProxy.$parent.$parent.$parent) {
                        paramCtx.$parent3 = parentProxy.$parent.$parent.$model;
                    }
                }
            }
            internal.calcCtx = paramCtx;
            internal.parentModel = parentProxy;
        }
        else {
            // używaj zwykłego modelu
            paramCtx.$root = obj.$root.$model;
            if (parent && parent.$parent) {
                paramCtx.$parent = parent.$parent.$model;
                if (parent.$parent.$parent) {
                    paramCtx.$parent2 = parent.$parent.$parent.$model;
                    if (parent.$parent.$parent.$parent) {
                        paramCtx.$parent3 = parent.$parent.$parent.$parent.$model;
                    }
                }
            }
            internal.calcCtx = paramCtx;
            internal.parentModel = parent ? parent.$model : {};
        }
    }
    // oblicz wartość
    if (!$schema.disabled) {
        if (internal.validateCalculations) {
            if (internal.calcFunction) {
                let thisModel = internal.parentModel;
                if ((0, defineSchema_1.isFunction)(schema.calc)) {
                    thisModel = (0, functions_1.createCtxProxy)({ options: {}, parent: internal.parentModel, calcCtx: internal.calcCtx });
                }
                internal.calcValue = internal.calcFunction.call(thisModel || internal.parentModel, internal.calcCtx);
            }
            else if (internal.aggregateFunction) {
                internal.calcValue = internal.aggregateFunction.call(internal.parentModel, internal.calcCtx);
            }
        }
        // console.log(JSON.stringify(schema));
        if (schema.type === 'number' || schema.type === 'money') {
            schemaIsNumber = true;
            if ($schema.fieldRequired && (data === undefined || data === null)) {
                if (setError('required')) {
                    return err;
                }
            }
            if (data !== undefined) {
                if (typeof data !== 'number') {
                    if (setError('type', schema.type, typeof data)) {
                        return err;
                    }
                }
                else {
                    dataIsNumber = true;
                }
            }
        }
        else if (schema.type === 'int' || schema.type === 'integer') {
            schemaIsNumber = true;
            if ($schema.fieldRequired && (data === undefined || data === null)) {
                if (setError('required')) {
                    return err;
                }
            }
            if (data !== undefined) {
                if (typeof data !== 'number') {
                    if (setError('type', schema.type, typeof data)) {
                        return err;
                    }
                    // result.valid = false;
                }
                else {
                    if (data % 1 !== 0) {
                        // result.valid = false;
                        if (setError('type', schema.type, 'float')) {
                            return err;
                        }
                    }
                    else {
                        dataIsNumber = true;
                    }
                }
            }
        }
        if (schemaIsNumber) {
            if (dataIsNumber) {
                if (internal.validateCalculations && data !== internal.calcValue) {
                    if (setError('calc', internal.calcValue)) {
                        return err;
                    }
                }
                for (const func of funcs) {
                    const res = func(data, $schema);
                    if (res) {
                        if (setError(res)) {
                            return err;
                        }
                    }
                }
            }
        }
        else {
            if (schema.type === 'string') {
                if ($schema.fieldRequired && (data === undefined || data === null || data === '')) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (typeof data !== 'string') {
                        if (setError('type', schema.type)) {
                            return err;
                        }
                    }
                    else {
                        // sprawdza czy wynik jest identyczny
                        if (internal.validateCalculations && data !== internal.calcValue) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (const func of funcs) {
                            const res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'boolean') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== undefined && typeof data !== 'boolean') {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && data !== internal.calcValue) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (const func of funcs) {
                            const res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'array') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== undefined && data !== null && !Array.isArray(data)) {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && JSON.stringify(data) !== JSON.stringify(internal.calcValue)) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (const func of funcs) {
                            const res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                        const length = $schema.length;
                        if (length !== undefined && data !== null) {
                            if (data.length !== length) {
                                if (setError('length', length)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'object') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== null && typeof data !== 'object') {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && JSON.stringify(data) !== JSON.stringify(internal.calcValue)) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (const func of funcs) {
                            const res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return err;
}
/**
 * wewnętrzna funkcja walidaująca
 *
 * @param {JSONSchema} schema schemat pola
 * @param {*} data aktualna wartość
 * @param {string} path ścieżka do pola
 * @param {IExtendedValidateOptions} options opcje walidacji
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @param {*} [parentProxy] obiekt nadrzędny obudowany schemaProxy
 */
function _validate(schema, data, path, options, parent, key, parentProxy) {
    const obj = {
        $key: key,
        $model: data,
        $parent: parent,
        $parent2: parent ? parent.$parent : {},
        $parent3: parent && parent.$parent ? parent.$parent.$parent : {}
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
        // tworzenie proxy dla nadrzędnego elementu
        if (!options.$rootProxy) {
            // wyłaczam Proxy, zobaczymy co się stanie
            options.$rootProxy = parentProxy = (0, schemaProxy_1.schemaProxy)(options.$rootSchema, obj.$root.$model, options.external);
        }
    }
    parentProxy = parentProxy || options.$rootProxy;
    if (schema.type === 'object') {
        validateField(schema, data, path, options, parent, key, parentProxy);
        const required = (schema.required || []);
        if (schema.properties && data) {
            const propParentProxy = parentProxy ? parentProxy[key] : null;
            for (const keyprop in schema.properties) {
                // for (let key of schema.$keys) {
                const element = schema.properties[keyprop];
                const value = data[keyprop];
                if (required.indexOf(keyprop) > -1 && element.fieldRequired === undefined) {
                    element.fieldRequired = true;
                }
                /*
                            if (element.fieldRequired || required.indexOf(key) > -1) {
                                if (value === undefined
                                    || (element.type === 'string' && !value)
                                    //|| (element.type === 'integer' && !value)
                                ) {
                                    // result.valid = false;
                                    result.errors.push({
                                        validation: 'required',
                                        path: path === '' ? key : path + '.' + key
                                    });
                                    if (exitOnFirstError) {
                                        continue;
                                    }
                                }
                            }
                            */
                // if (value !== undefined) {
                _validate(element, value, path === '' ? keyprop : path + '.' + keyprop, options, obj, keyprop, propParentProxy);
                // }
            }
        }
    }
    else if (schema.type === 'array') {
        validateField(schema, data, path, options, parent, key, parentProxy);
        // uniqueItems
        // contains
        const propParentProxy = parentProxy ? parentProxy[key] : null;
        const items = schema.items;
        if (items && data) {
            const subobj = {
                $key: 0,
                $model: null,
                $parent: obj,
                $parent2: obj.$parent,
                $parent3: obj.$parent2,
                $root: obj.$root
            };
            for (let i = 0; i < data.length; i++) {
                /*
                const subobj = {
                  $key: i,
                  $model: data[i],
                  $parent: obj,
                  $parent2: obj.$parent,
                  $parent3: obj.$parent ? obj.$parent.$parent : {},
                  $root: obj.$root
                };
                */
                subobj.$key = i;
                subobj.$model = data[i];
                _validate(items, data[i], path + '[' + i + ']', options, subobj, i, propParentProxy);
            }
        }
    }
    else {
        validateField(schema, data, path, options, parent, key, parentProxy);
    }
}
/**
 * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
 * @param data dane do sprawdzenia
 * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
 * @param path sciezka startowa pola, przy pominięciu ustawia pustą
 */
/**
 * Sprawdza poprawność danych według schematu i zawartej w nim walidacji
 *
 * @export
 * @param {JSONSchema} schema schemat danych
 * @param {*} data dane do sprawdzenia
 * @param {IValidateOptions} [options] opcje walidacji
 * @param {string} [path=''] aktualna ścieżka, używana potem w wynikach jako ścieżka bazowa
 * @returns {ValidationResult} wynik walidacji
 */
function validate(schema, data, options, path = '') {
    const options2 = {
        schemaMethods,
        validateCalculations: false,
        validationMessages: validationMessages_1.validationMessages,
        warningMessages: validationMessages_1.validationMessages,
        disableMessages: false,
        breakOnFirstError: true,
        errors: [],
        // fixData: false,
        external: {},
        $rootProxy: null,
        $rootSchema: null
        // disabledFields: {}
    };
    if (options) {
        (0, IOptions_1.mergeOptions)(options2, options);
    }
    if (schema.$parent === undefined) {
        if (Array.isArray(schema)) {
            schema = (0, fixAndMergeSchema_1.fixAndMergeSchema)(schema);
        }
        else {
            schema = (0, fixAndMergeSchema_1.fixAndMergeSchema)([schema]);
        }
    }
    if (schema.$options) {
        if (schema.$options.validationMessages) {
            options2.validationMessages = Object.assign({}, options2.validationMessages, schema.$options.validationMessages);
        }
        if (schema.$options.warningMessages) {
            options2.warningMessages = Object.assign({}, options2.warningMessages, schema.$options.warningMessages);
        }
    }
    options2.$rootSchema = schema;
    options2.$rootProxy = null;
    // const modelProxy = schemaProxy(schema, data, options2.external);
    _validate(schema, data, path || '', options2, null, null);
    const result = new ValidationResult_1.ValidationResult();
    result.errors = options2.errors;
    result.valid = result.errors.length === 0;
    return result;
}
exports.default = validate;
//# sourceMappingURL=validate.js.map